import { Recipient } from '@bonusly/recipient-entities';

export const createRecipientContent = (recipient: Recipient) => {
	return [
		{
			type: 'recipient',
			attrs: {
				id: recipient.username,
				record: recipient,
			},
		},
		{
			type: 'text',
			text: ' ',
		},
	];
};

export const createRecognitionContent = (recipient: Recipient) => {
	return {
		type: 'doc',
		content: [
			{
				type: 'paragraph',
				content: createRecipientContent(recipient),
			},
		],
	};
};
